import React, { FC } from 'react'
import styles from 'styles/components/header.module.scss'
import { push } from 'connected-react-router'
import { Spacer } from 'components/Utility'
import { useDispatch } from 'react-redux'

type Props = {
  childMenus: { label: string; url: string }[]
  handleMenuClose: () => void
}

const HeaderNavChildMenu: FC<Props> = (props) => {
  const { childMenus, handleMenuClose } = props
  const dispatch = useDispatch()
  return (
    <ul className={styles.nav__childList}>
      {childMenus.map((childMenu) => (
        <li key={childMenu.url}>
          <a
            className={styles.nav__childList__item}
            role={'button'}
            onClick={() => {
              handleMenuClose()
              dispatch(push(childMenu.url))
            }}
          >
            <Spacer size={12} axis={'horizontal'} />
            <span className={styles.nav__childList__item__label}>{childMenu.label}</span>
            <img
              className={styles.nav__list__item__arrow}
              src={'/icon/menu/next.svg'}
              alt={`${childMenu.label}を開く`}
            />
          </a>
        </li>
      ))}
    </ul>
  )
}

export default HeaderNavChildMenu
